// 韩语
const kr = {

    html: {
        title: "「AFK 아레나」 기간 한정 혜택-임의 금액 충전 시 한정 테두리 획득",
        description: "「AFK 아레나」 Lilith Store 전용 보상! Lilith Store로 이동하여 「AFK 아레나」에 임의 금액을 충전하면 한정 영구 테두리 [금빛 깃털 왕관]을 무료로 수령할 수 있습니다! 소중한 기회를 놓치지 마시고 지금 바로 전용 보상을 수령하세요!",
        Keywords: "AFK 아레나, AFK 아레나 iOS, AFK 아레나 앤드로이드, AFK 아레나 공식 홈페이지, 릴리스, AFK Arena, AFK 아레나 충전, Lilith, Lilith Games, Lilith Store, PlutoMall"
    },

    rule: {
        title: "이벤트 규칙",
        detial: `
            <p>1. 이벤트 기간: 2024년 9월 1일 0:00(UTC+0)부터 기간 한정 오픈</p>
            <p>2. 참여 방법: 2024년 9월 1일부터 Lilith Store에서 임의 금액을 충전하면 전용 아이템 보상을 획득할 수 있습니다.</p>
            <p>3. 보상 지급: 본 페이지에서 보상 수령 시 게임 내 우편함을 통해 지급됩니다.</p>
            <p>4. 이벤트 보상: 「AFK 아레나」 한정 테두리 “금빛 깃털 왕관” (획득 시 영구 유효)</p>
            <p>5. 이벤트 주의 사항</p>
            <p>(1) 아이템 수령 후 결제를 취소할 경우 지급된 아이템 보상이 회수될 수 있습니다.</p>
            <p>(2) 페이지 내 충전 데이터 반영까지는 약간의 딜레이가 있을 수 있습니다. 이런 경우 퀘스트를 완료한 후 페이지를 새로고침하시기 바랍니다. 이벤트 규칙에 따라 늦지 않게 이벤트에 참여하고 보상을 수령해 주시기 바랍니다. 주최 측 원인으로 이벤트 참여, 보상 교환 또는 수령에 실패하는 경우를 제외하고, 기간 내에 참여 또는 수령하지 않을 경우 이벤트 참여 또는 보상 수령을 포기한 것으로 간주합니다. 이로 인한 손실은 귀하의 부담이며, 주최 측은 어떠한 형식의 보상도 제공하지 않습니다.</p>
            <p>(3) 본 이벤트에 참여하는 과정에서 부적절한 행위(부정 수령, 악의적 편취 등이 포함되나 이에 국한되지 않음)가 적발될 경우 주최 측은 해당 유저의 본 이벤트 참여 자격을 박탈하고, 부적절하게 취득한 혜택을 철회할 권리 및 유저에게 법적 책임을 물을 권리를 가집니다.</p>
            <p>(4) 본 이벤트에 참여해 작성하거나 주최 측이 수집한 계정 닉네임, 계정 UID, 연락처(전화번호 등 포함) 및 기타 개인정보는 귀하가 본 이벤트 참여를 목적으로 자발적으로 제공하는 내용으로 간주되며, 주로 이벤트 신원 확인, 미성년자 충전 제한, 보상 지급, 소득세 납부(주최 측 또는 위탁받은 제삼자가 법에 의거하여 해당 세금에 대한 원천 징수의 의무를 이행함)에 이용됩니다. 귀하는 제공을 거부할 권리가 있으나, 거부 시 본 이벤트에 정상적으로 참여하지 못할 수 있습니다. 제출한 개인정보의 조회, 수정, 삭제, 철회하려는 경우나 개인정보 보호에 관해 문의 또는 불만 사항이 있으실 경우, 주최 측으로 연락 주시면 최대한 빠른 시일 내에 협조하여 처리해 드리겠습니다. 주최 측은 귀하가 제출하는 모든 개인정보 내용의 비밀을 엄수하나, 대외 홍보 및 마케팅 활동 등의 목적으로 귀하의 인터넷 플랫폼 닉네임, 휴대폰 번호(번호는 일부 가림 처리), 프로필 사진 등의 개인정보를 이용할 수 있습니다. 이러한 행위에는 공식 홈페이지에 당첨자 명단 게시, 언론 매체에 당첨자 정보 공개 등의 행위가 포함되나 이에 국한되지 않습니다.</p>
            <p>(5) 귀하는 인터넷에 존재하는 여러 불확정성 요소를 인지하고 있으며, 이를 이해하고 동의합니다. 불가항력의 상황, 네트워크 및 통신 회선 고장, 대규모 인터넷 마비 및 이벤트 중 발생한 대규모 부정행위 등 주최 측의 귀책이 아닌 사유로 본 이벤트에 차질이 생기거나 이벤트를 계속 진행하기 어려울 경우, 주최 측은 각종 방법으로 이상 상황을 해결하거나 이벤트 조정, 중지, 취소 등의 조치를 취할 권리가 있습니다. 이로 인해 발생하는 손실은 주최 측이 책임지지 않습니다.</p>
            <p>(6) 주최 측은 법령이 허용하는 범위 내에서 본 이벤트의 설명 및 기타 규칙을 변경하거나 수정할 권한이 있습니다. 관련 변동이나 조정은 이벤트 페이지, 주최 측 공식 SNS상에 게시되며, 게시 즉시 효력이 발생합니다. 수정된 이벤트 설명 및 기타 규칙에 이의가 있을 경우 이벤트 참여를 즉시 중단해 주시기 바랍니다. 본 이벤트에 계속 참여하는 행위는 이벤트 설명 및 기타 규칙 수정에 동의하신 것으로 간주됩니다.</p>
            <p>(7) 본 이벤트는 Lilith Games가 주최하는 이벤트로 문의 사항은 afkarena-service@lilithgames.com으로 연락해 주시기 바랍니다. 본 이벤트는 Apple과 무관합니다.</p>
        `,
    },

    login: {
        login: "로그인",
        logout: "로그아웃",
        changeRole: "캐릭터 전환",
    },

    role: {
        title: "로그인 캐릭터 선택",
        label1: "닉네임",
        label2: "서버",
    },

    header: {
        timeTxt: "9월 1일 0:00(UTC+0)부터 Lilith Store에서 「AFK 아레나」에 임의 금액을 충전하면 한정 테두리 보상을 받을 수 있습니다!",
        txt: "한정 테두리: 금빛 깃털 왕관",
        toPay: "충전",
        toSubmit: "수령",
        submitEnd: "수령 완료"
    },

    sys: {
        200: "한정 테두리를 수령했습니다! 게임 내 우편함을 확인해 주세요!",
        405: "시스템 오류, 잠시 후 다시 시도해 주시거나 고객센터로 연락 바랍니다."
    },

    btnOk: "확인",

    toast:'캐릭터 정보를 불러오지 못했습니다.',
    awaitTxt:'결제 완료 후, 몇 분 정도 기다린 뒤 새로고침하시면 보상을 수령하실 수 있습니다'

}
// 导出
export default kr;
